import type { JobportalCoursesFilter } from './jobportal-courses-store';

const arrayFields = [
  'categories',
  'employment_types',
  'driving_licenses',
  'languages',
  'salary_types',
  'places_of_work',
  'regions',
  'educations',
] as const;
const textFields = ['search', 'age_min', 'age_max', 'min_salary', 'max_salary'] as const;

export function parseCourseFilters(params: Pick<URLSearchParams, 'get'>): JobportalCoursesFilter {
  const filter: JobportalCoursesFilter = {
    order: params.get('order') === 'asc' ? 'asc' : 'desc',
    orderBy: ['salary', 'distance'].includes(params.get('orderBy') || '')
      ? (params.get('orderBy') as 'salary' | 'distance')
      : 'created_at',
  };
  for (const field of arrayFields) {
    const values = params.get(field)?.split(',').filter(Boolean);
    if (values?.length) filter[field] = values;
  }
  for (const field of textFields) {
    const value = params.get(field);
    if (value) filter[field] = value;
  }
  return filter;
}

export function courseFilterParams(filter: JobportalCoursesFilter, current = '') {
  const params = new URLSearchParams(current);
  for (const field of [...arrayFields, ...textFields, 'order', 'orderBy'] as const) {
    const value = filter[field];
    if (value !== undefined && String(value) !== '') params.set(field, String(value));
    else params.delete(field);
  }
  params.delete('page');
  return params.toString();
}

export function coursePage(raw: string | null) {
  const value = Number(raw);
  return Number.isSafeInteger(value) && value > 0 ? value : 1;
}
